'use strict'
import store from '@/store'
import {
  Message
} from 'iview'
const pushConfig = {
  enable: true,
  needBadge: true,
  needPushNick: true,
  pushContent: '',
  custom: '测试自定义数据',
  pushPayload: '',
  sound: '',
  forceKeepCalling: 0
}
const sessionConfig = {
  videoQuality: WebRTC.CHAT_VIDEO_QUALITY_HIGH,
  videoFrameRate: WebRTC.CHAT_VIDEO_FRAME_RATE_15,
  videoBitrate: 0,
  recordVideo: false,
  recordAudio: false,
  highAudio: true,
  bypassRtmp: false,
  rtmpUrl: '',
  rtmpRecord: false,
  splitMode: WebRTC.LAYOUT_SPLITLATTICETILE
}
let callTimer = null

function sendVoice(netcall, mtAccount, type) {
  let callType =
    type == 'video' ? WebRTC.NETCALL_TYPE_VIDEO : WebRTC.NETCALL_TYPE_AUDIO
  // let timeLock = false

  callTimer = setTimeout(function (netcall) {
  if (netcall && !netcall.callAccepted) {
      netcall.hangup()
      Message['error'] &&
        Message['error']({
          duration: 3,
          content: '超时未接听'
        })
      store.commit('prvateConsultation/setShowSaveModal', false)
      console.log('超时未接听, hangup', netcall)
    }
  }, 1000 * 30 )


  netcall
    .call({
      type: callType,
      account: mtAccount,
      pushConfig: {
        enable: true,
        needBadge: true,
        needPushNick: true,
        pushContent: pushConfig,
        custom: JSON.stringify({
          key: 'value'
        })
      },
      sessionConfig: sessionConfig
    })
    .then(
      obj => {
        console.log('呼叫成功', netcall)


        // 在回调里监听对方加入通话，并显示对方的视频画面
        netcall.on('remoteTrack', function (obj) {
          console.log('user join', obj)
          // 播放对方声音
          netcall
            .startDevice({
              type: WebRTC.DEVICE_TYPE_AUDIO_OUT_CHAT
            })
            .catch(function (err) {
              console.log('播放对方的声音失败')
              console.error(err)
            })
          // 预览对方视频画面
          netcall.startRemoteStream({
            account: mtAccount,
            node: document.getElementById('remoteContainer')
          })
          // 设置对方预览画面大小
          netcall.setVideoViewRemoteSize({
            account: mtAccount,
            width: 500,
            height: 500,
            cut: true
          })
        })
        // netcall.on('remoteTrack', function (obj) {})
        // 被叫拒绝的通知
        netcall.on('callRejected', function (obj) {
          Message['error'] &&
            Message['error']({
              duration: 3,
              content: '被叫拒绝的通知'
            })
          console.log('on callRejected 被叫拒绝的通知', obj)
          obj.channelId = netcall.channelId
          obj.type = 1
          store
            .dispatch('prvateConsultation/fetchVideoChannelIdReport', obj)
            .then(res => {
              netcall.hangup()
              // 取消呼叫倒计时
              clearCallTimer()
            })
          store.commit('prvateConsultation/setShowSaveModal', false)
        })

        // 被叫接受的通知
        netcall.on('callAccepted', function (obj) {
          // 缓存呼叫类型，后面开启音视频连接需要用到
          console.log('on callAccepted 被叫接受的通知', obj)
          obj.type = 0
          store
            .dispatch('prvateConsultation/fetchVideoChannelIdReport', obj)
            .then(res => {
              // 取消呼叫倒计时
              clearCallTimer()
            })

          // 连接媒体网关
          netcall
            .startRtc()
            .then(function () {
              // 开启麦克风
              return netcall
                .startDevice({
                  type: WebRTC.DEVICE_TYPE_AUDIO_IN
                })
                .catch(function (err) {
                  console.log('启动本地麦克风失败')
                  console.error(err)
                })
            })
            .then(function () {
              // 设置采集音量
              netcall.setCaptureVolume(255)
              console.log('callType', callType)
              if (callType == 2) {
                // 开启摄像头
                return netcall
                  .startDevice({
                    type: WebRTC.DEVICE_TYPE_VIDEO
                  })
                  .catch(function (err) {
                    console.log('启动本地摄像头失败')
                    console.error(err)
                  })
              }
            })
            .then(function () {
              // 预览本地画面
              var node = document.getElementById('localContainer')
              netcall.startLocalStream(node)

              // 设置本地预览画面大小
              netcall.setVideoViewSize({
                width: 500,
                height: 500,
                cut: true
              })
            })
            .catch(function (err) {
              console.log('发生错误')
              console.log(err)
              netcall.hangup()
              clearCallTimer()
            })
        })

        // 收到对方的挂断通知
        netcall.on('hangup', function (obj) {
          console.log('on callAccepted 收到对方的挂断通知', obj)
          obj.type = 2
          store
            .dispatch('prvateConsultation/fetchVideoChannelIdReport', obj)
            .then(res => {
              netcall.hangup()
              // 取消呼叫倒计时
              clearCallTimer()
            })
          store.commit('prvateConsultation/setShowSaveModal', false)
        })

      },
      err => {
        // console.log(344586958)
        netcall.hangup()
        // 取消呼叫倒计时
          clearCallTimer()
        Message['error'] &&
          Message['error']({
            duration: 3,
            content: '对方不在线'
          })
        store.commit('prvateConsultation/setShowSaveModal', false)
        // 被叫不在线
        if (err.code === 11001) {
          console.log('callee offline', err)
        }
      }
    )

  
  
}





const clearCallTimer = ()  => {
  console.log("取消倒计时")
  clearTimeout(callTimer)
}

/**
 * 初始化 音视频信令
 * @param {*} netcall
 */
const initSignal = (netcall, mtAccount, type) => {
  // 接通音视频
  sendVoice(netcall, mtAccount, type)
}

export default {
  initSignal,
  clearCallTimer
}



// WEBPACK FOOTER //
// ./src/im/signal.js